import GTM from '../../gtm/GTM';
import GTMBookingDatesUnavailableModel from '../../gtm/models/GTMBookingDatesUnavailableModel';

export default abstract class TrackListing {
    public static trackBookingDatesUnavailableEvent(): void {
        if (!this.#hasAvailabilityError()) {
            return;
        }

        GTM.track(GTMBookingDatesUnavailableModel.parseToGTMData());
    }

    static #hasAvailabilityError(): boolean {
        const meta = document.querySelector<HTMLMetaElement>('meta[id="has-availability-error"]');

        return !!meta;
    }
}
